import { atom } from "jotai";

export const enhancedPromptAtom = atom<string>("");
enhancedPromptAtom.debugLabel = "enhancedPromptAtom";
